import React from 'react';
import { Button, Container, Navbar } from 'react-bootstrap';

import { generateAuthUrl, generateCodeChallenge, generateCodeVerifier } from '../utils/auth';
import { setCodeVerifier } from '../utils/storage';

import LOGO from '../../core/assets/img/iabilet-logo.svg';

const LoginContainer = () => {
    const handleLogin = async () => {
        const codeVerifier = generateCodeVerifier();
        const codeChallange = await generateCodeChallenge(codeVerifier);
        setCodeVerifier(codeVerifier);
        window.location.href = generateAuthUrl(codeChallange);
    };

    return (
        <Container className="d-flex justify-content-center vh-100">
            <div className="login-container">
                <div className="login-header d-flex align-items-center mb-5">
                    <Navbar.Brand className="mx-auto" href="/">iaBilet</Navbar.Brand>
                </div>
                <div className="login-block bg-white rounded m-3">
                    <h2 className="fw-bold">Bine ai venit</h2>
                    <p className="mb-5">Intră în contul tău</p>
                    <div className="connect__btns d-grid gap-2 mt-2 mb-3">
                        <Button variant="outline-dark" size="lg" type="submit" block onClick={handleLogin}>
                            Login cu
                            <img src={LOGO} alt="IaBilet" className="logo-iabilet img-fluid ms-2"/>
                        </Button>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default LoginContainer;
